export enum EUFinanceReactQueryKeySegment {
  EUFINANCE = "eufinance",
  CONTACTS = "contacts",
  ME = "me",
  CASES = "cases",
  CASE_ATTACHMENTS = "case-attachments",
  BY_CASE_ID = "by-case-id",
  BY_CASE_ATTACHMENT_ID = "by-case-attachment-id",
  PERMISSIONS = "permissions",
  FILESTORE = "allowed-mime-type-to-extensions-map",
  ALLOWED_MIME_TYPE_TO_EXTENSIONS_MAP = "allowed-mime-type-to-extensions-map",
}

export const EUFinanceReactQueryKey = {
  GET_ME: [
    EUFinanceReactQueryKeySegment.EUFINANCE,
    EUFinanceReactQueryKeySegment.CONTACTS,
    EUFinanceReactQueryKeySegment.ME,
  ],
  GET_CASE_ATTACHMENTS_BY_CASE_ID: [
    EUFinanceReactQueryKeySegment.EUFINANCE,
    EUFinanceReactQueryKeySegment.CASES,
    EUFinanceReactQueryKeySegment.CASE_ATTACHMENTS,
    EUFinanceReactQueryKeySegment.BY_CASE_ID,
  ],
  GET_CASE_ATTACHMENTS_BY_CASE_ATTACHMENT_ID: [
    EUFinanceReactQueryKeySegment.EUFINANCE,
    EUFinanceReactQueryKeySegment.CASES,
    EUFinanceReactQueryKeySegment.CASE_ATTACHMENTS,
    EUFinanceReactQueryKeySegment.BY_CASE_ATTACHMENT_ID,
  ],
  GET_CASE_ATTACHMENTS_PERMISSIONS: [
    EUFinanceReactQueryKeySegment.EUFINANCE,
    EUFinanceReactQueryKeySegment.CASES,
    EUFinanceReactQueryKeySegment.CASE_ATTACHMENTS,
    EUFinanceReactQueryKeySegment.PERMISSIONS,
  ],
  GET_ALLOWED_MIME_TYPE_TO_EXTENSIONS_MAP: [
    EUFinanceReactQueryKeySegment.EUFINANCE,
    EUFinanceReactQueryKeySegment.FILESTORE,
    EUFinanceReactQueryKeySegment.ALLOWED_MIME_TYPE_TO_EXTENSIONS_MAP,
  ],
};
